<template>
  <v-dialog justify='center' :value="value" persistent width="650">
    <v-form ref="form">
    <v-card color="fill" flat class='overflow-hidden'>
      <v-card-title :class="title">Ad Clone</v-card-title>
      <v-row dense justify="center">
        <v-col cols='7'>
          <v-text-field 
            :class="body" 
            :rules="adNameRules" 
            v-model="ad.ad_name"
            background-color="input" 
            label="New Ad Name" 
            autocomplete="off"
            dense 
            outlined 
            clearable>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols='4'>
          <v-menu 
            ref="menu1" 
            v-model="menu1" 
            :close-on-content-click="false" 
            bottom 
            nudge-top="25" 
            :nudge-left="10"
            transition="scale-y-transition" 
            offset-y 
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                :class="body" 
                :value="formattedStart" 
                label="Start Date" 
                background-color="input"
                prepend-inner-icon="mdi-calendar" 
                :rules="[v => !!v ||  'Start Date Required']"
                readonly 
                v-bind="attrs" 
                v-on="on" 
                clearable 
                outlined 
                dense
                @click:clear="resetStartDate">
              </v-text-field>
            </template>
            <v-date-picker 
              :show-current="ad.end_date || selectedAd.ad_start_date" 
              color="accent"
              v-model="ad.start_date" 
              @input="menu1 = false" 
              no-title 
              :max="ad.end_date">
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols='4'>
          <v-menu 
            ref="menu2" 
            v-model="menu2" 
            :close-on-content-click="false" 
            bottom 
            nudge-top="25" 
            :nudge-left="10"
            transition="scale-y-transition" 
            offset-y 
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                :class="body" 
                :value="formattedEnd" 
                outlined dense 
                background-color="input"
                label="End Date" 
                prepend-inner-icon="mdi-calendar" 
                :rules="[v => !!v ||  'End Date Required']"
                readonly 
                v-bind="attrs" 
                v-on="on" 
                clearable  
                @click:clear="resetEndDate">
              </v-text-field>
            </template>
            <v-date-picker 
              :show-current="ad.start_date || selectedAd.ad_end_date" 
              color="accent"
              v-model="ad.end_date" 
              @input="menu2 = false" 
              no-title 
              :min="ad.start_date">
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols='8'>
          <v-textarea 
            :class="body" 
            outlined dense 
            background-color="input" 
            label="Notes (Optional)" 
            no-resize
            rows="3" 
            v-model="ad.note" 
            clearable>
          </v-textarea>
        </v-col>
      </v-row>
      <v-toolbar flat color="fill">
        <v-spacer/>
        <v-btn 
          :class="body" 
          text 
          :disabled="cloning"
          @click="$emit('update:value', false)">
          Close
        </v-btn>
        <v-btn 
          :class="body" 
          class="success white--text"
          :disabled="!validClone || cloning"
          :loading="cloning"
          @click.stop="cloneAd">
          {{ $auth.tenant === 'alliance-retail-group' ? 'Clone' : 'Copy' }}
        </v-btn>
      </v-toolbar>
    </v-card>
    </v-form>
    <FeaturePromoWarnings
      v-if="warningsModal" 
      v-model="warningsModal"
      :selectedAd="selectedAd" 
      :gappedPromos="gappedPromos"
      :move="true"
      :adClone="true"
      @cancel="warningsModal = false" 
      @confirmAction="confirmAction">
    </FeaturePromoWarnings>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
import { displayAlert } from '@/mixins/alert'
const FeaturePromoWarnings = () => import('@/components/features/promotions/FeaturePromoWarnings.vue')
export default {
  data () {
    return {
      adNameRules: [
        value => !!value && value.trim().length > 0 || 'Name is Required',
        value => (value || '').length <= 52 || '52 characters maximum',
      ],
      ad:{
        ad_name: '',
        start_date: '',
        end_date: '',
        note:''
      },
      menu1: false,
      menu2: false,
      cloning: false,
      warningsModal: false,
      gappedPromos: []
    }
  },
  name: 'AdCopy',
  mixins: [displayHelpers, displayAlert],
  components: { FeaturePromoWarnings },
  props: {
    value: Boolean,
    selectedAd: Object,
    defaultParty: Object
  },
  computed: {
    formattedStart () {
      return this.ad.start_date ? this.moment(this.ad.start_date).format(this.$dateConfig.date_display) : ''
    },
    formattedEnd () {
      return this.ad.end_date ? this.moment(this.ad.end_date).format(this.$dateConfig.date_display) : ''
    },
    validClone () {
      return ((this.ad.ad_name && this.ad.ad_name.trim().length > 0) && this.ad.start_date && this.ad.end_date)
    }
  },
  methods: {
    resetStartDate() {
      this.ad.start_date = ''
    },
    resetEndDate() {
      this.ad.end_date = ''
    },
    async cloneAd(checkPromos = true) {
      const valid = this.$refs.form.validate()
      if (!valid) {
        return this.$store.dispatch('setSnackbar', { status: 'error', text: 'Please check your form for errors' })
      }
      this.cloning = true
      try {
        if (this.$auth.tenant === 'alliance-retail-group' && checkPromos) {
          await this.checkPromoGap()
          if (this.gappedPromos.length > 0) {
            this.cloning = false
            return this.warningsModal = true
          }
        }
        await this.$Ads.clone(this.selectedAd.id, this.ad)
        this.$emit('refresh')
        this.$emit('update:value', false)
        this.$store.dispatch('setSnackbar', { status: 'success', text: `Clone In Progress` })
      } catch (err) {  
        console.error(err)      
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Clone failed due to ${err?.response?.data?.message || err.message}` })
      } finally {
        this.cloning = false
      }
    },
     async checkPromoGap() {
      this.gappedPromos = []
      try {
        const params = {
          source_ad_id: this.selectedAd.id,
          start_date: this.ad.start_date,
          end_date: this.ad.end_date
        }
        const { data } = await this.$Ads.checkAdPromoGap(params)
        this.gappedPromos = data
      } catch (err) {
        this.handleError(err)
      }
    },
    confirmAction () {
      this.warningsModal = false
      this.cloneAd(false)
    }
  }
}
</script>
<style scoped>
.card {
  overflow-x:hidden;
}
</style>
